<script>
import FileExports from '@/components/exporters/FileExports'

export default {
  components: {
    FileExports,
  },
}
</script>

<template>
  <div class="file-import-export">
    <h1 class="mar-b-xl">
      Import & Export
    </h1>
    <div class="file-import-export__winddown-notice pad-t-xl mar-b-xl">
      <h2>Library Import</h2>
      <p>
        Italic Type is winding down, so we are no longer processing library imports at this time.
        You can still export your reading history below.
      </p>
    </div>
    <FileExports id="exports" class="file-import-export__section" />
  </div>
</template>

<style lang="scss" scoped>
.file-import-export {
  width: 80%;
  position: relative;
  padding: 0 6rem 0 8rem;

  @include respond-to('small') {
    width: 100%;
    padding: 1.25rem 2.5rem 0;
  }

  &__section {
    border-top: 1px solid $color-section-head-border;
    padding-top: 3rem;
  }

  &__winddown-notice {
    h2 {
      margin-bottom: 1rem;
    }

    p {
      color: $color-gray-dark;
      line-height: 1.6;
    }
  }
}

h1 {
  text-align: left;
}
</style>
